import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SpecialService } from '../services/special.service';
import { ContractService } from '../services/contract.service';
import { GLOBAL } from '../services/global';
import { VariableService } from '../services/sharedVariables';
import { Privileges } from '../models/privileges.model';

@Component({
  selector: 'printer',
  templateUrl: '../views/core/printer.html',
  providers: [SpecialService,ContractService]
})
export class PrinterComponent{
  public title: string;
  public contracts: any[];
  public searchContracts:any[];
  public message: any;
  public mode: string;
  public searchByName:string;
  public searchByFolio:string;
  public searchByDate:string;
  public linkToPdf: string;
  public wait:boolean;
  public contractPrivilege:number;
  public privileges:Privileges[];


  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private specialService: SpecialService,
    private contractService: ContractService,
    public sharedVariables: VariableService
  )
  {
      this.title = null;
      this.mode = "submit-add";
      this.searchByName = null;
      this.searchByFolio = null;
      this.searchByDate = null;
      this.searchContracts = null;
      /*this.linkToPdf = "http://localhost/funerariaapi/reports/contracts/1-20181005";*/
      this.linkToPdf = null;
      this.contractPrivilege = null;
      this.wait = true;
  }

  /*ngOnInit()
  {
    console.log("mode",this.mode);
    console.log(this.sharedVariables);
    if(this.sharedVariables.validSession()){
      this.getAllContracts();
    }
    else
      this.title = "Error, Sesión no iniciada";
  }*/
  ngOnInit()
  {
    console.log("mode",this.mode);
    console.log(this.sharedVariables);
    this.sharedVariables.validSession();
    setTimeout(()=> {
              if(this.sharedVariables.login){
                this.getPrivileges();
                console.log(this.privileges);
                setTimeout(()=> {
                                  if(this.contractPrivilege == 1){
                                    this.getAllContracts();
                                    this.wait = false;
                                  }
                                  else{
                                  this.title = "Permisos insuficientes para el usuario";
                                  this.wait=false;
                                }
                                },this.sharedVariables.timeToLoad);
    }
    else
      this.title = "Error, Sesión no iniciada";
    },this.sharedVariables.sessionTime);
  }

  getAllContracts()
  {
    this.specialService.getContractDetail().subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.contracts = result.data;
          console.log(this.contracts);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  getAllContractsByName(name:string)
  {
    this.specialService.getContractDetailByName(name).subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
          this.contracts = null;
        }else{
          this.contracts = result.data;
          console.log(this.contracts);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  getAllContractsByFolio(folio:number)
  {
    this.specialService.getContractDetailByFolio(folio).subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
          this.contracts = null;
        }else{
          this.contracts = result.data;
          console.log(this.contracts);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  getAllContractsByDate(from:string,to:string)
  {
    this.specialService.getContractDetailByDate(from,to).subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
          this.contracts = null;
        }else{
          this.contracts = result.data;
          console.log(this.contracts);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

 generateContract(service_id:number,id_contract:number,customer_id:number,report_name:string)
 {
   this.contractService.generateContract(service_id,id_contract,customer_id,report_name).subscribe(
     result => {
       if(result.code != 200)
       {
         console.log(result);
       }else{
         setTimeout(()=> {
                          this.linkToPdf = result.data;
                          console.log("link para el pdf",this.linkToPdf);
                          window.open(this.linkToPdf,'_blank');
                        },this.sharedVariables.timeToReport);
       }
     },error => {
      console.log(<any>error);
     }
   );
 }
 showResults(from:any,to:any)
 {
   console.log("from - to",from);
 }
  onSubmit()
  {

  }
  getPrivileges()
  {
    this.sharedVariables.getPrivileges().subscribe(
        response => {
          if(response.code == 200){
            this.contractPrivilege = response.data[0].contract;
            console.log("Privilegios del usuario",this.contractPrivilege);
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }

  showMessage(msg:string)
  {
    window.alert("Se va a imprimir el reporte"+msg);
  }

}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/printer.component.ts